import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumLeadStatus implements BaseEnumType {
  private static allValues: EnumLeadStatus[] = []; // make sure this is top-most
  
  public static active = new EnumLeadStatus(0, "Active", "enum_lead_status_active");
  public static onHold = new EnumLeadStatus(1, "OnHold", "enum_lead_status_on_hold");
  public static lost = new EnumLeadStatus(2, "Lost", "enum_lead_status_lost");
  public static won = new EnumLeadStatus(3, "Won", "enum_lead_status_won");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumLeadStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isActive() { return this === EnumLeadStatus.active; }
  public isOnHold() { return this === EnumLeadStatus.onHold; }
  public isLost() { return this === EnumLeadStatus.lost; }
  public isWon() { return this === EnumLeadStatus.won; }

  public static getValues(): readonly EnumLeadStatus[] {
    return EnumLeadStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumLeadStatus[] {
    return EnumLeadStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumLeadStatus {
    const found = EnumLeadStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumLeadStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumLeadStatus): EnumLeadStatus {
    const found = name ? EnumLeadStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumLeadStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumLeadStatus>): boolean {
    return this.key === other?.key;
  }
}